// extracted by mini-css-extract-plugin
module.exports = {"loading":"idt-orderbutton_loading__n9bnq","spinner":"idt-orderbutton_spinner__27n_l"};